// Pure layout data for the 3D boutique (no three.js here, so the page itself can import it).

// World layout of the boutique. The back wall is at z = WALL_Z and the shelving stands against it.
export const WALL_Z = -3.2
export const SHELF_DEPTH = 0.9
export const SHELF_FRONT_Z = WALL_Z + SHELF_DEPTH
export const DOLL_Z = WALL_Z + SHELF_DEPTH * 0.55
export const BOARD = 0.08

export type BayId = 'left' | 'center' | 'right'

export interface Bay {
    id: BayId
    x: number
    width: number
    height: number
    panel: string
}

export const BAYS: Array<Bay> = [
    { id: 'left', x: -3.45, width: 3.3, height: 4.4, panel: '#F2D3D8' },
    { id: 'center', x: 0, width: 3.5, height: 4.3, panel: '#C9D6BE' },
    { id: 'right', x: 3.45, width: 3.3, height: 4.4, panel: '#EFE0CC' }
]

export const bayById = (id: BayId): Bay => BAYS.find(bay => bay.id === id) ?? BAYS[1]

export interface ShelfSpec {
    id: string
    bay: BayId
    categorySlug: string | null
    y: number
    kind: 'shelf' | 'hooks' | 'domes' | 'yarn'
    capacity: number
    // The "Koleksi Baru" shelf takes 3D products whose own shelf is full or whose category has no shelf.
    overflow?: boolean
    // Camera framing when this shelf is picked in the shelf navigation (defaults: 0.35 lift, 2.6 distance).
    cameraLift?: number
    cameraDistance?: number
}

// y is the centre of the shelf board; dolls stand on y + BOARD / 2.
// Each shelf shows the products of one category (by its slug) that have a 3D model.
export const SHELVES: Array<ShelfSpec> = [
    { id: 'teddy', bay: 'left', categorySlug: 'boneka-beruang', y: 3.2, kind: 'shelf', capacity: 4 },
    { id: 'rabbits', bay: 'left', categorySlug: 'boneka-kelinci', y: 2, kind: 'shelf', capacity: 4 },
    { id: 'animals', bay: 'left', categorySlug: 'boneka-hewan', y: 0.8, kind: 'shelf', capacity: 4 },
    { id: 'keychains', bay: 'right', categorySlug: 'gantungan-kunci-rajut', y: 3.2, kind: 'hooks', capacity: 5 },
    { id: 'custom', bay: 'right', categorySlug: 'boneka-custom', y: 2, kind: 'shelf', capacity: 4 },
    { id: 'yarn', bay: 'right', categorySlug: null, y: 0.8, kind: 'yarn', capacity: 0 },
    { id: 'limited', bay: 'center', categorySlug: 'edisi-terbatas', y: 2.05, kind: 'domes', capacity: 3 },
    // Lower centre shelf, behind the pedestal: the camera looks over the pedestal doll to see it.
    { id: 'new', bay: 'center', categorySlug: null, y: 0.8, kind: 'shelf', capacity: 4, overflow: true, cameraLift: 1.4, cameraDistance: 4.6 }
]

// Slots on the "Koleksi Baru" shelf leave the middle free, where the pedestal doll stands in front.
export const OVERFLOW_SLOTS = [-0.92, 0.92, -1.42, 1.42]
export const OVERFLOW_LABEL = 'Koleksi Baru'
export const OVERFLOW_LABEL_X = -1.05

export const CENTER_SHELVES = [0.8, 2.05, 3.25]
export const SIDE_SHELVES = [0.8, 2, 3.2]

export const PEDESTAL = { x: 0, z: -0.45, topY: 0.66, radius: 0.85 }

export const DOME = { radius: 0.34, height: 0.62, baseHeight: 0.06 }

export const SHELF_NAV: Array<{ id: string, categorySlug: string | null, fallback: string }> = [
    { id: 'teddy', categorySlug: 'boneka-beruang', fallback: 'Boneka Beruang' },
    { id: 'rabbits', categorySlug: 'boneka-kelinci', fallback: 'Boneka Kelinci' },
    { id: 'animals', categorySlug: 'boneka-hewan', fallback: 'Boneka Hewan' },
    { id: 'limited', categorySlug: 'edisi-terbatas', fallback: 'Edisi Terbatas' },
    { id: 'keychains', categorySlug: 'gantungan-kunci-rajut', fallback: 'Gantungan Kunci' },
    { id: 'custom', categorySlug: 'boneka-custom', fallback: 'Boneka Custom' },
    { id: 'new', categorySlug: null, fallback: 'Koleksi Baru' },
    { id: 'pedestal', categorySlug: null, fallback: 'Terlaris' }
]
